/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component';
const styles_DataTableRowWrapperComponent:any[] = ([] as any[]);
export const RenderType_DataTableRowWrapperComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableRowWrapperComponent,data:{}});
function View_DataTableRowWrapperComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(null as any));
}
function View_DataTableRowWrapperComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_DataTableRowWrapperComponent_3)),i0.ɵdid(540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],ngOutletContext:[1,
          'ngOutletContext']},(null as any)),i0.ɵpod({row:0}),(_l()(),i0.ɵand(0,(null as any),
      (null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.rowDetail.template;
    const currVal_1:any = _ck(_v,2,0,_co.row);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_DataTableRowWrapperComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'datatable-row-detail']],[[4,'height','px']],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableRowWrapperComponent_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_1:any = (_co.rowDetail && _co.rowDetail.template);
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.detailRowHeight;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_DataTableRowWrapperComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_DataTableRowWrapperComponent_1)),i0.ɵdid(16384,
      (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.DataTableRowWrapperComponent = _v.component;
    const currVal_0:any = _co.expanded;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_DataTableRowWrapperComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'datatable-row-wrapper',
      [['class','datatable-row-wrapper']],(null as any),[[(null as any),'contextmenu']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('contextmenu' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onContextmenu($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_DataTableRowWrapperComponent_0,RenderType_DataTableRowWrapperComponent)),
      i0.ɵdid(49152,(null as any),0,i2.DataTableRowWrapperComponent,([] as any[]),
          (null as any),(null as any))],(null as any),(null as any));
}
export const DataTableRowWrapperComponentNgFactory:i0.ComponentFactory<i2.DataTableRowWrapperComponent> = i0.ɵccf('datatable-row-wrapper',
    i2.DataTableRowWrapperComponent,View_DataTableRowWrapperComponent_Host_0,{rowDetail:'rowDetail',
        detailRowHeight:'detailRowHeight',expanded:'expanded',row:'row'},{rowContextmenu:'rowContextmenu'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3ctd3JhcHBlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9ib2R5LXJvdy13cmFwcGVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vc3JjL3VpL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9ib2R5LXJvdy13cmFwcGVyLmNvbXBvbmVudC5kLnRzLkRhdGFUYWJsZVJvd1dyYXBwZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy91aS9ub2RlX21vZHVsZXMvQHN3aW1sYW5lL25neC1kYXRhdGFibGUvcmVsZWFzZS9jb21wb25lbnRzL2JvZHkvYm9keS1yb3ctd3JhcHBlci5jb21wb25lbnQuZC50cy5EYXRhVGFibGVSb3dXcmFwcGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuICAgIDxkaXYgXG4gICAgICAqbmdJZj1cImV4cGFuZGVkXCJcbiAgICAgIFtzdHlsZS5oZWlnaHQucHhdPVwiZGV0YWlsUm93SGVpZ2h0XCIgXG4gICAgICBjbGFzcz1cImRhdGF0YWJsZS1yb3ctZGV0YWlsXCI+XG4gICAgICA8bmctdGVtcGxhdGVcbiAgICAgICAgKm5nSWY9XCJyb3dEZXRhaWwgJiYgcm93RGV0YWlsLnRlbXBsYXRlXCJcbiAgICAgICAgW25nVGVtcGxhdGVPdXRsZXRdPVwicm93RGV0YWlsLnRlbXBsYXRlXCJcbiAgICAgICAgW25nT3V0bGV0Q29udGV4dF09XCJ7IHJvdzogcm93IH1cIj5cbiAgICAgIDwvbmctdGVtcGxhdGU+XG4gICAgPC9kaXY+XG4gICIsIjxkYXRhdGFibGUtcm93LXdyYXBwZXI+PC9kYXRhdGFibGUtcm93LXdyYXBwZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ1N5Qzs7O29CQUhuQztNQUFBLDZDQUFBO01BQUE7VUFBQSwwQ0FHRTs7O0lBREE7SUFDQTtJQUhGLFdBRUUsVUFDQSxTQUhGOzs7O29CQUpGO01BQUE7TUFBQSxnQkFHK0IsNkNBQzdCO01BQUE7YUFBQTtVQUFBLHdCQUljOzs7SUFIWjtJQURGLFdBQ0UsU0FERjs7O0lBRkE7SUFGRixXQUVFLFNBRkY7Ozs7b0JBRkosa0RBQ0k7TUFBQSxHQUF5QiwyQ0FDekI7TUFBQSwyRUFBQTtNQUFBO01BQUEsZUFTTTs7SUFSSjtJQURGLFdBQ0UsU0FERjs7OztvQkNGSjtNQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQTthQUFBO1VBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/~/@swimlane/ngx-datatable/release/components/body/body-row-wrapper.component.ngfactory.ts